<div class="error-message-popover">
    <div class="error-message-popover__content">
        <h2 class="error_message-popover__title">{{ title }}</h2>
        <p class="error_message__description"> {{ description}}</p>
        <div> 
            <button class="cta cta--primary" (click)="onClickHandler()">{{ buttonText }}</button>
        </div>
    </div>
</div>